import type { TRootState } from 'store';
import type { ISelector } from 'interfaces/Selector.interface';
import { createSelectorSlice } from 'redux/collections/helper/createSelector.slice';
import {
  currentPageDefault,
  itemsPerPageDefault,
} from 'redux/collections/consts/selectorDefaults.consts';

export const contactsSlice = createSelectorSlice(
  'paginatedContacts',
  currentPageDefault,
  itemsPerPageDefault
);

const { actions, reducer } = contactsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
} = actions;

export const paginatedContactsSelector = (state: TRootState): ISelector =>
  state.collectionContacts;

export default reducer;
